"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Card_1 = __importDefault(require("@material-ui/core/Card"));

var CardActions_1 = __importDefault(require("@material-ui/core/CardActions"));

var CardMedia_1 = __importDefault(require("@material-ui/core/CardMedia"));

var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../../constants");

var GridList_1 = __importDefault(require("../GridList"));

var useStyles_1 = __importDefault(require("./useStyles"));
/**
*  Moment for listing External Resources.
*/


var ReferenceMoment = function ReferenceMoment(props) {
  var data = props.data;
  var classes = (0, useStyles_1.default)(props);

  var key = function key(label, property, index) {
    return label + "-" + property + "-" + index;
  };
  /* eslint-disable react/jsx-props-no-spreading */


  return react_1.default.createElement(GridList_1.default, __assign({}, props, {
    bodyClassName: classes.body,
    containerProps: {
      spacing: 5
    }
  }), data.map(function (_a, index) {
    var description = _a.description,
        image = _a.image,
        label = _a.label,
        property = _a.property,
        url = _a.url;
    return react_1.default.createElement(Grid_1.default, {
      className: classes.item,
      item: true,
      key: key(label, property, index),
      lg: 4,
      md: 5
    }, react_1.default.createElement(Card_1.default, {
      raised: true
    }, image && react_1.default.createElement(CardMedia_1.default, {
      component: "img",
      image: image,
      title: property + " logo"
    }), react_1.default.createElement(CardContent_1.default, {
      className: classes.content
    }, react_1.default.createElement(Typography_1.default, {
      variant: "h5"
    }, property), react_1.default.createElement("a", {
      className: classes.label,
      href: url,
      rel: "noreferrer",
      target: "_blank"
    }, react_1.default.createElement(Typography_1.default, {
      variant: "subtitle1"
    }, label)), react_1.default.createElement(Typography_1.default, {
      color: "textSecondary",
      variant: "caption"
    }, description)), react_1.default.createElement(CardActions_1.default, {
      className: classes.actions
    }, url && react_1.default.createElement(Button_1.default, {
      className: classes.button,
      color: "primary",
      href: url,
      size: "small",
      target: "_blank",
      variant: "outlined"
    }, "Learn More"))));
  }));
};

ReferenceMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Stories-API data context. */
  data: prop_types_1.default.arrayOf(prop_types_1.default.object).isRequired,

  /** Determines the `GridListSection` `Icon` of the `Moment`. */
  icon: prop_types_1.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `GridListSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** The layout name of the `Moment` */
  layout: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
ReferenceMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  layout: constants_1.MomentLayout.Reference,
  type: constants_1.MomentType.Reference
});
exports.default = ReferenceMoment;